const transitionPageDataAr = {
    title : "التحول لعمليات خالية من الانبعاثات",
    praghraphOne : "يهدف اتفاق باريس بشأن تغير المناخ إلى الحد من زيادة درجة الحرارة العالمية دون درجتين مئويتين فوق مستويات ما قبل الحقبة الصناعية، ومواصلة الجهود الرامية إلى الحد من ارتفاع درجة الحرارة عند 1.5 درجة مئوية. ولتحقيق هذا الهدف على المدى الطويل، يجب على جميع البلدان أن تستهدف الوصول إلى الحياد الكربوني وتصفير انبعاثات الغازات الدفيئة خلال العقود الثلاثة القادمة. يُدرك بنك الأول أن معالجة قضايا تغير المناخ تمثل تحدياً عاجلاً ومعقداً، يتطلب تحولاً جوهرياً في الاقتصاد العالمي. لذلك التزم البنك بتحقيق صافي انبعاثات صفرية في عملياته بحلول العام 2035. يتطلب الوصول إلى هذا الإنجاز اتخاذ خطوات فعالة لقياس ومراقبة وتقليل الانبعاثات المرتبطة باستهلاك الطاقة، فضلاً عن الانبعاثات غير المباشرة الأخرى للبنك. وإلى جانب جهوده المستمرة للتقليل من أثره على البيئة، يتطلع البنك إلى استكشاف مجالات وطرق جديدة لخفض بصمته الكربونية خلال الأعوام القادمة.",
    sectionOne : {
        title : "أبرز نقاط عام 2022",
        gridOne : [
            {
                icon : {
                    name : "led.svg",
                    alt : "",
                },
                number : {
                    value : 20070,
                    unit : "",
                },
                label : "تركيب",
                subtitle : <p>مصباح LED منخفض استهلاك الطاقة في المباني الرئيسية لبنك الأول، مما يجنب استهلاك</p>,
                nubmerTwo : {
                    value : 78519,
                    unit : "",
                }, 
                subtitleTwo : <p>كيلو جرام من الطاقة المكافئة المولدة من الفحم سنوياً</p>
            },
            {
                icon : {
                    name : "earth.svg",
                    alt : "",
                },
                label : "توفير",
                number : {
                    value : 1688306,
                    unit : "",
                },
                subtitle : <p>كيلوواط ساعة من الطاقة سنوياً باستخدام نظام التدفئة والتهوية وتكييف الهواء الجديد</p>,
                nubmerTwo : null, 
                subtitleTwo : "",
            },
            {
                icon : {
                    name : "bottol.svg",
                    alt : "",
                },
                number : {
                    value : 2600000,
                    unit : "",
                },
                label : "توفير",
                subtitle : <p>علب المياه البلاستيكية ذات الاستخدام الواحد سنوياً من خلال استخدام برادات المياه</p>,
                nubmerTwo : null, 
                subtitleTwo : "",
            }
        ],
        gridTwo : [
            {
                icon : {
                    name : "document.svg",
                    alt : "",
                },
                label : "الاستغناء عن",
                number : {
                    value : 2760000,
                    unit : ""
                },
                subtitle : <p>كشف حساب ورقي مع تحول العملاء إلى كشوف الحسابات الإلكترونية</p>,
                nubmerTwo : null, 
                subtitleTwo : "",
            },
            {
                icon : {
                    name : "governance.svg",
                    alt : "",
                },
                number : {
                    unit : ""
                },
                subtitle : <p>أول بنك في المملكة العربية السعودية يتخلص من شفاطات الشرب البلاستيكية علب المياه البلاستيكية في مكاتب البنك</p>,
                nubmerTwo : null, 
                subtitleTwo : "",
            }
        ],
        cardOne : {
            icon : {
                name : "recycle.svg",
                alt : "",
            },
            title : {
                value : 374926,
                unit : " كيلوغرام من النفايات المعاد تدويرها"
            },
            subtitle : "ومن المتوقع أن يسهم البرنامج إعادة التدوير التجريبي لعام 2022:",
        }
    },
    sectionThree : [
        {
            colOne : {
                number : {
                    value : 6373,
                    unit : ""
                },
            },
            colTwo : "شجرة"
        },
        {

            colTwo : "نفايات",
            colOne : {
                number : {
                    value : 937,
                    unit : <span> متراً مكعباً</span>
                },
            },
        },
        {
            colOne : {
                number : {
                    value : 9933287,
                    // unit : <span>m<sup className="power-number">3</sup></span>
                },
            },
            colTwo : "لتر مياه",
        },
        {
            // type : "two",
            colOne : {
                number : {
                    // value : 2160593,
                    unit : <span style={{ fontSize : 42 }}>ما يكافئ 2,160,593  كيلوواط ساعة</span>,
                },
            },
            colTwo : "من الطاقة"
        }
    ],
    sectionFour : {
        title : "مشروع المستقبل: المكتب الذكي الجديد لبنك الأول",
        subtitle : "وتضمنت جهودنا الرامية إلى توسيع نطاق الاستدامة البيئية في عملياتنا تحديث مكاتبنا لتعزيز التحول نحو ممارسات أكثر استدامة. ويتضمن المقر الرئيسي الجديد لبنك الأول، والمتوقع الانتقال إليه خلال الربع الثالث من العام 2023، أفضل عناصر المباني الذكية والمستدامة. وتم تجهيز البرج، المكون من 30 طابقاً، بتكنولوجيا رقمية متطورة تدعم المنظومة البيئية المستدامة للمبنى. ونتيجة لذلك، حصل البرج المصرفي الجديد لبنك الأول على الشهادة الذهبية للريادة في تصميمات الطاقة LEED، والتي تعد واحدة من أكثر شهادات المباني الخضراء شهرة على مستوى العالم. نظرا لتصميمه الرائد والمتطور بيئياً، سيوفر المقر الرئيسي الجديد لبنك الأول فوائد بيئية متعددة، بما في ذلك:",
        cards : [
            {
                number : 28.47,
                title : "انخفاض استهلاك الطاقة التشغيلية",
                subtitle : "",
            },
            {
                number : 59.25,
                title : "انخفاض استهلاك المياه للمسطحات الخضراء",
                subtitle : "بفضل اختيار نباتات قليلة استهلاك المياه واستعمال أنظمة وري فعالة",
            },
            {
                number : 54.3,
                title : "انخفاض استهلاك المياه داخل المبنى ",
                subtitle : "بفضل تجهيزات أدوات المياه ذات الكفاءة العالية",
            },
            {
                number : 54.6,
                title : "انخفاض استهلاك طاقة الإنارة",
                subtitle : "من خلال استخدام تقنيات الإنارة الفعالة مثل مصابيح LED ومستشعرات الضوء والاستغلال الأمثل لضوء النهار الطبيعي"
            },
            {
                number : 30,
                title : "زيادة في تدفق الهواء الخارجي ",
                subtitle : "بحسب توصيات تصميم المبنى بهدف تحسين جودة الهواء الداخلي",
            },
            {
                number : null,
                title : "استخدام ثلاجات متوافقة مع معايير المحافظة على البيئة",
                subtitle : "وذات تأثيرات طفيفة على الاحتباس الحراري ولا تشكل أي خطر على طبقة الأوزون",
            },
            {
                number : null,
                title : "نسبة منخفضة من المركبات العضوية المتطايرة ",
                subtitle : "لتقليل الانبعاثات الضارة وتحسين صحة الموظفين داخل المبنى"
            }
        ],
        paragraphOne : "وكان من المهم بالنسبة للبنك أن تكون عملية بناء البرج صديقة للبيئة قدر الإمكان، ونحن فخورون بتحقيق الإنجازات التالية:",
        cardsTwo : [
            {
                number : 28,
                title : "من مواد البناء التي تم شراؤها حتى الآن هي مواد",
                subtitle : "مُعاد تدويرها",
            },
            {
                number : 49.4,
                title : "من المواد المستخدمة في المشروع",
                subtitle : "مستوردة من مصادر محلية تم شراؤها من موردين إقليميين ضمن نطاق 500 ميل من المشروع",
            },
            {
                number : 70,
                title : "من الطاقة الكهربائية المستخدمة",
                subtitle : "يتم تعويضها من خلال شراء شهادات الطاقة المتجددة",
            },
            {
                number : 75,
                title : "من مخلفات البناء تم إعادة تدويرها",
                subtitle : "حيث تم إرسال النفايات المعدنية والخشبية والخرسانية والورقية والبلاستيكية إلى مراكز إعادة التدوير",
            }
        ],
        paragraphTwo : "* يتم احتساب هذه الكفاءات على أساس سنوي",
        paragraphThree : "وتوفر المساحات المكتبية الحديثة للعملاء والموظفين بيئة عمل تعكس الأسس الحقيقية للاستدامة، من دون المساومة على البنية التحتية المتطورة لتكنولوجيا المعلومات والاتصالات، بما يضمن بيئة عمل حديثة وفعالة."
    }
}

export default transitionPageDataAr;